module.exports = __webpack_public_path__ + "76af7631867c5c5b45d536e37133842b.png";